export default "__VITE_ASSET__02ab5402__"